import styles from '../../assets/styles/LandingPage/Article.module.scss';
import React from 'react';
import Header3 from './Header3';
import Footer from './Footer';
import { MimaButton, MimaText } from '../../components';
import img_solution from '../../assets/img/img_solution.png';
import img_unlock from '../../assets/img/img_unlock.png';
import img_benefits from '../../assets/img/img_benefits.png';
import img_everything from '../../assets/img/img_everything.png';
import img_payroll from '../../assets/img/img_payroll.png';
import { Link } from 'react-router-dom';
import constant from '../../utils/constant';


const ArticleCard = ({ src, date, title, body, onClick }) => {
    return (
        <div className={styles.container_card}>
            <img
                src={src}
                alt='Article'
            />
            {/* <MimaText variant="smallBold" mt={2} mb={2}>{date}</MimaText> */}
            <MimaText variant="bodyBold" mt={2} mb={2}>{title}</MimaText>
            <MimaText variant="body2" mb={8}>{body}</MimaText>
            <MimaButton
                title="Learn more"
                width={18}
                mb={4}
                onClick={onClick}
            />
        </div>
    )
}


const Article = () => {

    return (
        <>
            <Header3 />
            <div className={styles.container}>
                <MimaText variant="h2" align="center" mb={4}>
                    Articles
                </MimaText>
                <div className={styles.container_cards}>
                    <Link to={constant.Routes.Article1}>
                        <ArticleCard
                            src={img_benefits}
                            date="05 August 2023"
                            title="Benefits of Digital Business Management"
                            body="Digital business management plays a vital role in today's digital age. By effectively utilizing digital technologies, businesses can optimize operations, improve customer experiences, and drive growth in an increasingly digital and interconnected world..."
                        />
                    </Link>

                    <Link to={constant.Routes.Article2}>
                        <ArticleCard
                            src={img_solution}
                            date="04 August 2023"
                            title="Business Management Solutions: Streamlining Operations and Driving Success"
                            body="In today's rapidly evolving business landscape, effective management is crucial for the success and growth of any organization. Business management solutions encompass a range of strategies, tools, and practices designed to optimize operations, enhance efficiency, and drive overall success..."
                        />
                    </Link>
                    <Link to={constant.Routes.Article3}>
                        <ArticleCard
                            src={img_everything}
                            date="03 August 2023"
                            title="Everything you need to know about the MimaBusiness Pay Bills Feature"
                            body="In today’s fast paced world, individuals are looking for better and faster ways to save time and make their lives more easier nd convenient. One of the most time consuming and frustrating tasks is paying bills...."
                        />
                    </Link>
                    <Link to={constant.Routes.Article4}>
                        <ArticleCard
                            src={img_payroll}
                            date="02 August 2023"
                            title="Streamline your Payroll Management with Mima: The Ultimate Solution for Business Owners"
                            body="Efficient payroll management is a crucial aspect of running a business. However, it can be time-consuming and complex, especially for small business owners juggling multiple responsibilities..."
                        />
                    </Link>
                    <Link to={constant.Routes.Article5}>
                        <ArticleCard
                            src={img_unlock}
                            date="01 August 2023"
                            title="Unlock your Business Potential with Mima: The Best Business Management Software"
                            body="Running a business involves juggling various tasks, from managing finances to streamlining operations and staying organized. While business management software can be a game-changer, finding a solution that is both powerful and budget-friendly can be a challenge..."
                        />
                    </Link>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Article;